import React from "react";
import HeaderOne from "../header/HeaderOne";
import BannerOne from "../elements/BannerOne";
import AboutOne from "../elements/AboutOne";
import ServiceOne from "../elements/ServiceOne";
import WorkingProcess from "../elements/WorkingProcess";
// import FunFacts from "../elements/FunFacts";
// import Team from "../elements/Team";
// import Portfolio from "../elements/Portfolio";
import FaqOne from "../elements/FaqOne";
import TestimonialsBrand from "../elements/TestimonialsBrand";
// import Contact from "../elements/Contact";
// import Blog from "../elements/Blog";
import Footer from "../elements/Footer";
import SideBar from "../components/SideBar";

// DATA
import { DataBannerOne } from "../data/DataBanner";
import { DataAboutOne } from "../data/DataAbout";
import { DataServiceOne } from "../data/DataService";
import { dataWorkingProcess } from "../data/DataWorkingProcess";
// import { DataProject } from "../data/DataProject";
import { DataFaqOne } from "../data/Faq";
// import { DataFunFactsOne } from "../data/DataFunFacts";
import { DataBrandsOne } from "../data/DataBrands";
// import { DataContactOne } from "../data/DataContact";

function Home() {
  return (
    <div className="index-one">
      <HeaderOne />
      <main>
        <BannerOne DataBannerOne={DataBannerOne} />
        <AboutOne dataAbout={DataAboutOne} />
        <ServiceOne dataService={DataServiceOne} />
        <WorkingProcess dataWorkingProcess={dataWorkingProcess} />
        {/* <Portfolio DataProject={DataProject} /> */}
        <FaqOne dataFaq={DataFaqOne} />

        {/* <FunFacts dataFunFacts={DataFunFactsOne} /> */}

        <TestimonialsBrand dataBrands={DataBrandsOne} />
        {/* <Contact dataContact={DataContactOne} /> */}

        {/* <div style={{ paddingTop: "120px" }}></div> */}

        <Footer />
        <SideBar />
      </main>
    </div>
  );
}

export default Home;
